<script setup lang="ts">
import Meau from "./Meau.vue";
import { ArrowDown } from "@element-plus/icons-vue";
import { ref, onMounted, onUnmounted, reactive, computed } from "vue";
import logoHead from "./../../../assets/imgs/logo_head.png";
import logoHeadEn from "./../../../assets/imgs/logo_headEn.png";
import { useRoute, useRouter } from "vue-router";
import {
  ElMessage,
  ElDropdown,
  ElDropdownMenu,
  ElDropdownItem,
  ElIcon,
} from "element-plus";
import { useI18n } from "vue-i18n";
// 切换语言
const { locale, t } = useI18n();
const route = useRoute();
const router = useRouter();
const handleCommand = (command) => {
  const lang = command === "en" ? "en" : "zh";
  const currentPath = router.currentRoute.value.path;
  const query = router.currentRoute.value.query;
  
  // 获取当前路径中除语言外的部分
  const pathWithoutLang = currentPath.replace(/^\/(zh|en)/, '');
  
  // 构建新路径
  const newPath = `/${lang}${pathWithoutLang}`;
  
  // 更新语言设置
  localStorage.setItem("locale", command);
  
  // 保持查询参数不变并跳转
  router.push({
    path: newPath,
    query: query
  }).then(() => {
    window.location.reload();
  });
};
const state = reactive({
  yuyan: "中文",
});

// 顶部是否隐藏的状态
const isHidden = ref(false);

// 在滚动事件中更新滚动距离
const updateScrollDistance = () => {
  const currentScroll = window.scrollY;
  const scrollDelta = currentScroll - scrollDistance.value;
  // 当滚动距离大于200px时，显示顶部；当向上滚动时，显示顶部
  isHidden.value = scrollDelta > 0 && currentScroll > 200;
  scrollDistance.value = currentScroll;
};
const scrollDistance = ref(0);
const logoSrc = computed(() => {
  return locale.value === "en" ? logoHeadEn : logoHead;
});
// 监听滚动事件
onMounted(() => {
  state.yuyan = localStorage.getItem("locale") == "en" ? "EN" : "中文";
  window.addEventListener("scroll", updateScrollDistance);
});

// 组件卸载时移除滚动事件监听器
onUnmounted(() => {
  window.removeEventListener("scroll", updateScrollDistance);
});
</script>

<template>
  <div :class="{ hidden: isHidden }">
    <header :class="{ 'fixed-header': !isHidden }">
      <div class="h_t">
        <div class="middle inner">
          <div class="logo">
            <RouterLink to="/" class="a">
              <img :src="logoSrc" alt="" />
            </RouterLink>
          </div>
          <div class="h_right">
            <div class="h_right_t">
              <!-- <RouterLink to="/login" class="lg">
                <i class="iconfont O icon-zhanghaodenglu1"></i>
                <em class="em">{{ $t("system.home.concact.em") }}</em>
              </RouterLink> -->
              <div class="q_h">
                <a href="javascript:;">
                  <i class="iconfont t icon-yuyan"></i>
                  <el-dropdown @command="handleCommand">
                    <div class="el-dropdown-link">
                      <span v-text="state.yuyan"></span>
                    </div>
                    <template #dropdown>
                      <el-dropdown-menu class="x_l">
                        <el-dropdown-item command="en">EN</el-dropdown-item>
                        <hr color="ded6d6" />
                        <el-dropdown-item command="zh-cn"
                          >中文</el-dropdown-item
                        >
                      </el-dropdown-menu>
                    </template>
                  </el-dropdown>
                </a>
              </div>
            </div>
            <div class="h_right_b">
              <Meau></Meau>
            </div>
          </div>
        </div>
      </div>
    </header>
  </div>
</template>

<style lang="scss" scoped>
@import url("//at.alicdn.com/t/c/font_4480395_uoo2ksad56.css");

.O,
.t {
  font-size: 14px;
}
header {
  width: 100%;
  height: 120px;
  position: relative;
  transform: translateY(0);
  transition: transform 0.5s ease-in-out;
}

.fixed-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1003;
  animation: slideDown 0.5s ease-in-out;
}

.hidden header {
  transform: translateY(-100%);
}

@keyframes slideDown {
  from {
    transform: translateY(-100%);
  }
  to {
    transform: translateY(0);
  }
}

.h_t {
  height: 120px;
  background: #fff;
  min-width: 605px;
  box-shadow: 0 3px 7px 0 rgba(50, 53, 53, 0.5);
  will-change: transform; // 优化动画性能
}

.h_t .inner {
  display: flex;
  justify-content: space-between;
  flex-wrap: nowrap;
}

.inner {
  width: 100%;
  height: 100%;
  margin: 0 auto;
  padding: 0 15px;
  max-width: 1200px;
  background-color: #fff;
}

.logo {
  display: flex;
  align-items: center;
  height: 100%;
}

.logo .a {
  min-width: 100px;
  min-height: 100px;
  text-decoration: none;
  outline: none;
  color: #3e3a39;
  display: flex;
  align-items: center;
}

.logo .a img {
  vertical-align: middle;
  height: 100px;
  width: auto;
  min-width: 100px;
  min-height: 30px;
  object-fit: contain; // 确保图片比例正确
}

img {
  border: none;
  max-width: 100%;
}
em {
  padding: 0 5px;
  font-style: normal;
}
.h_right {
  width: auto;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  padding-top: 10px;
}

.h_right_t {
  display: flex;
  gap: 20px;
  align-items: center;
  margin-bottom: 15px;
}

.h_right_b {
  margin-top: auto;
  margin-bottom: 20px;
}

.lg,
.q_h a {
  display: flex;
  align-items: center;
  gap: 5px;
  color: #696b71;
  font-size: 14px;

  &:hover {
    color: #004080;
  }
}

// 移除之前添加的 top-bar 相关样式
</style>
